import { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { useAuthStore } from '../store/authstore';
import { useInstituteStore } from '../store/institutestore';
import { getPrintSchoolName } from '../utils/printSchoolName';

/** Swap the document title to the school name while printing so the browser
 *  header never shows the product brand. Restore it afterwards. */
export function PrintTitleBinder() {
  const brandingName = useInstituteStore((state) => state.branding.schoolName);
  const instituteName = useAuthStore((state) => state.session?.user.instituteName);
  const schoolName = brandingName?.trim() || instituteName?.trim() || '';

  useEffect(() => {
    const onBeforePrint = () => {
      document.documentElement.dataset.appTitle = document.title;
      document.title = schoolName;
    };
    const onAfterPrint = () => {
      const previous = document.documentElement.dataset.appTitle;
      if (previous != null) document.title = previous;
      delete document.documentElement.dataset.appTitle;
    };
    window.addEventListener('beforeprint', onBeforePrint);
    window.addEventListener('afterprint', onAfterPrint);
    return () => {
      window.removeEventListener('beforeprint', onBeforePrint);
      window.removeEventListener('afterprint', onAfterPrint);
    };
  }, [schoolName]);

  return null;
}

export function PrintSchoolHeader({
  schoolName,
  className,
}: {
  schoolName?: string;
  className?: string;
}) {
  const name = (schoolName ?? getPrintSchoolName()).trim();
  if (!name) return null;

  return (
    <Box
      className={className}
      sx={{
        textAlign: 'center',
        mb: 2.5,
        pb: 1.5,
        borderBottom: '1px solid #e2e8f0',
      }}
    >
      <Typography
        component="h1"
        sx={{ fontSize: 20, fontWeight: 800, color: '#0f172a', letterSpacing: 0.2, lineHeight: 1.2 }}
      >
        {name}
      </Typography>
    </Box>
  );
}
